// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-container {
  width: auto;
  padding-right: 26px;
  z-index: 100;
  position: fixed;
  bottom: 64px;
  right: 0px;
}
.menu-container .menu-button {
  width: 68px;
  height: 68px;
  cursor: pointer;
  border-radius: 200px;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/action-button/action-button.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EAGA,oBAAA;EACA,cAAA;AADJ","sourcesContent":[".menu-container {\r\n  width: auto;\r\n  padding-right: 26px;\r\n  z-index: 100;\r\n  position: fixed;\r\n  bottom: 64px;\r\n  right: 0px;\r\n\r\n  .menu-button {\r\n    width: 68px;\r\n    height: 68px;\r\n    cursor: pointer;\r\n    // background-color: rgba(255, 255, 255, 1);\r\n\r\n    border-radius: 200px;\r\n    display: block;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
